@if (displayName) {
  <button mat-icon-button class="square-button rounded-circle" [ngStyle]="getCellStyles(displayName)">
    {{ displayName }}
  </button>
} @else {
  <img src="/assets/images/common/unassigned.png" class="square-button rounded-circle unassigned" [ngStyle]="getCellStyles(displayName)" />
}
